export default __webpack_public_path__ + "static/media/image5.8ecf19ce.jpg";